import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap";
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

const UnassignedLeads = (props) => {
  const { user, role, setCurrentLead, setIsAddForm } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  // console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      if (user?.role == "Admin")
        getLeads();
      else if (user?.role == "Dealer")
        getLeadsByModer();
    }
  }, [user]);

  useEffect(() => {
    setColumns([
      {
        name: 'Lead Name',
        selector: row => row.name,
      },
      {
        name: 'Client Email',
        selector: row => row.email,
      },
      {
        name: 'Client Mobile',
        selector: row => row.mobile,
      },
      {
        name: 'Description',
        cell: (row) => <>
        <span title={row?.intro}>{row.intro.length > 30 ? row.intro.substring(0, 30) + '...' : row.intro}</span>
        </>,
      },
      {
        name: 'Project',
        selector: row => row.project.length > 0 ? row.project[0]?.name : ' - ',
      },
      user?.role == "Admin" &&
      {
        cell: (row) => <>
          <AvForm style={{ textAlign: 'left' }}>
            <AvField onChange={(e) => assignToDealer(row, e.target.value)} style={{ minWidth: 100, padding: 5, paddingLeft: 8, paddingRight: 8 }}
              type="select"
              name="assignToD"
              placeholder={"Select Channel Partner"}
            >
              <option value="">Select Channel Partner</option>
              {dealers.map((item) => {
                if (item?.projectId == row?.project[0]?._id)
                  return <option key={item?._id} value={item?._id}>{item.name}</option>
              })}
            </AvField>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Assign To',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => props?.history.push("/auto/lead/" + row?._id)}
            title={"View"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {user?.role == 'Admin' &&
            <Button onClick={() => handleArchivedLead(row)}
              title={"Archive"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-archive-arrow-down" style={{ fontSize: 20 }}></span></Button>
          }
          {user?.role == 'Admin' || row?.addedBy == user?._id ?
            <Button onClick={() => handleUpdateLead(row)}
              title={"Edit"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
            : null
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [dealers]);

  const getLeads = async () => {
    await getDealers();
    console.log('getting leads unassigned');
    get("/lead/auto/list?kind=unassigned&companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getLeadsByModer = async () => {
    await getDealers();
    get("/lead/list/moderator?kind=unassigned&companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getDealers = () => {
    get("/dealer/list?companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get user list', json);
        if (json.statusCode == 200) {
          setDealers(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const assignToDealer = (lead, dealerId) => {
    let moder = dealers.find(x => x._id == dealerId);
    setModalData({ type: "Assign", lead: lead, userName: moder.name, userId: dealerId });
    setIsModal(true);
  }

  const handleArchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Archive", lead: lead });
    setIsModal(true);
  }

  const handleUpdateLead = (item) => {
    setCurrentLead(item);
    setIsAddForm(true);
  }

  const onConfirm = () => {
    let body = {};
    if (modalData?.type == 'Assign') {
      body = { lead_id: modalData?.lead?._id, timeline: [...modalData?.lead?.timeline, { title: 'Assign To Channel Partner', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }], assignToD: modalData?.userId, token: user?.token };
    } else if (modalData?.type == 'Archive') {
      body = { lead_id: modalData?.lead?._id, timeline: [...modalData?.lead?.timeline, { title: 'Archived', desc: `Lead Archived by ${user?.name}.` }], status: 'Archived', token: user?.token };
    }
    put("/lead/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
          props?.setReload(!props?.reload);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => setIsModal(false)}
          data={modalData}
        />
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={{
            headCells: {
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: 15,
                maxWidth: 80
              },
            },
            cells: {
              style: {
                maxWidth: 50
              }
            }
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default UnassignedLeads;
